import React from 'react';
import { Search } from 'lucide-react';

export const SearchFieldIcon: React.FC = () => (
  <span className="pointer-events-none absolute inset-y-0 left-0 flex h-full w-10 items-center justify-center text-gray-400">
    <Search className="h-4 w-4" aria-hidden="true" />
  </span>
);
